/**
 * RemoteConfigurations Types and Constants
 *
 * This file contains constants, column definitions, and JSDoc type definitions
 * for the RemoteConfigurations feature.
 */

// Environment options for configurations
var ENVIRONMENT_OPTIONS = [
  { value: 'stg', label: 'Staging' },
  { value: 'dev', label: 'Development' },
  { value: 'prod', label: 'Production' },
];

// Value options for each environment/distribution/farming unit
var VALUE_OPTIONS = [
  { value: 'true', label: 'True' },
  { value: 'false', label: 'False' },
];

// Filter options for environment dropdown
var ENVIRONMENT_FILTER_OPTIONS = [
  { value: 'all', label: 'All Environments' },
  { value: 'prod', label: 'Production' },
  { value: 'stg', label: 'Staging' },
  { value: 'dev', label: 'Development' },
];

// Filter options for status dropdown
var STATUS_FILTER_OPTIONS = [
  { value: 'all', label: 'All Statuses' },
  { value: 'enabled', label: 'Enabled' },
  { value: 'disabled', label: 'Disabled' },
];

// Table column definitions
var TABLE_COLUMNS = [
  {
    key: 'configuration_name',
    label: 'Name',
    width: '180px',
    minWidth: '180px',
    sortable: true,
  },
  {
    key: 'default_value',
    label: 'Default Status',
    width: '120px',
    minWidth: '120px',
    sortable: true,
  },
  {
    key: 'environments',
    label: 'Environments',
    width: '130px',
    minWidth: '130px',
    sortable: true,
  },
  {
    key: 'targeting',
    label: 'Targeting',
    width: '250px',
    minWidth: '200px',
    sortable: true,
  },
  {
    key: 'updated_at',
    label: 'Updated',
    width: '100px',
    minWidth: '100px',
    sortable: true,
  },
  {
    key: 'actions',
    label: 'Actions',
    width: '160px',
    minWidth: '160px',
    sortable: false,
  },
];

// Toast notification durations
var TOAST_DURATION = 3000;
var TOAST_FADE_DURATION = 200;

// Default filter state
var DEFAULT_FILTERS = {
  search: '',
  environment: 'all',
  status: 'all',
};

// Default sort configuration
var DEFAULT_SORT = {
  key: 'configuration_name',
  direction: 'asc',
};

// Empty configuration template
var EMPTY_CONFIGURATION = {
  configuration_name: '',
  default_value: false,
  description: '',
  environments: [],
  users_email: [],
  distributions: [],
  farming_units: [],
  extra_data: '',
};

/**
 * @typedef {Object} Configuration
 * @property {string} id - Unique identifier
 * @property {string} configuration_name - Name of the configuration
 * @property {boolean} default_value - Default enabled/disabled state
 * @property {string} description - Description of what this config does
 * @property {Array<string>} environments - Array of environment overrides
 * @property {Array<string>} distributions - Array of distribution overrides
 * @property {Array<string>} farming_units - Array of farming unit overrides
 * @property {Array<string>} users_email - Array of user email overrides
 * @property {string} extra_data - JSON string of additional data
 * @property {string} [created_at] - ISO timestamp of creation
 * @property {string} [created_by] - User email who created
 * @property {string} [updated_at] - ISO timestamp of last update
 * @property {string} [updated_by] - User email who last updated
 */

/**
 * @typedef {Object} FilterState
 * @property {string} search - Search query for name
 * @property {string} environment - Selected environment filter
 * @property {string} status - Selected status filter
 */

/**
 * @typedef {Object} SortConfig
 * @property {string} key - Column key to sort by
 * @property {string} direction - 'asc' or 'desc'
 */

/**
 * @typedef {Object} ToastState
 * @property {boolean} show - Whether toast is visible
 * @property {string} type - 'success' or 'error'
 * @property {string} message - Toast message
 */

/**
 * @typedef {Object} ModalState
 * @property {boolean} isOpen - Whether modal is visible
 * @property {Configuration|null} editingConfig - Config being edited, null for new
 */

module.exports = {
  ENVIRONMENT_OPTIONS: ENVIRONMENT_OPTIONS,
  VALUE_OPTIONS: VALUE_OPTIONS,
  ENVIRONMENT_FILTER_OPTIONS: ENVIRONMENT_FILTER_OPTIONS,
  STATUS_FILTER_OPTIONS: STATUS_FILTER_OPTIONS,
  TABLE_COLUMNS: TABLE_COLUMNS,
  TOAST_DURATION: TOAST_DURATION,
  TOAST_FADE_DURATION: TOAST_FADE_DURATION,
  DEFAULT_FILTERS: DEFAULT_FILTERS,
  DEFAULT_SORT: DEFAULT_SORT,
  EMPTY_CONFIGURATION: EMPTY_CONFIGURATION,
};
